module.exports = __webpack_public_path__ + "img/simcard.b768e043.svg";